import React from "react";
import { DateTime } from "luxon";
import { useStateContext } from "../contexts/ContextProvider";

const BillsCard = (props) => {
  const { bills, setCurrentBillId } = props;
  const { handleModal } = useStateContext();
  return (
    <div className="flex justify-center pt-2 px-5 h-3/6">
      <div className="w-full md:max-w-[500px] border-gray-300 border-1 rounded-2xl overflow-clip">
        <div className="grid grid-cols-3 h-10 w-full bg-gray-100 border-gray-300 border-b-1 pl-5 pr-4 py-2">
          <div className="pl-2">Date</div>
          <div className="text-center">Type</div>
          <div className="text-right">Total</div>
        </div>
        {bills.length > 0 && (
          <div>
            <ul className="h-52 overflow-hidden overflow-y-auto pb-8">
              {bills.map((item, index) => {
                return (
                  <li
                    key={item.id}
                    className="grid grid-cols-3 items-center border-gray-300 border-2
                   hover:border-snappily-orange rounded-xl m-0.5 p-2 my-1 capitalize"
                    onClick={() => {
                      setCurrentBillId(item.id);
                      handleModal("editBill");
                    }}
                  >
                    <div className="text-left pl-2">
                      {DateTime.fromFormat(
                        item.serviceEnd,
                        "yy-MM-dd"
                      ).toFormat("MMM-yyyy")}
                    </div>
                    <div
                      className="text-center truncate 
                    text-ellipsis"
                    >
                      {item.billType.split("pays")[1] + " Bill"}
                    </div>
                    {/* <div className="text-right pr-0">
                      {item.roomIds.length}
                      {item.roomIds.length > 1 ? " Rooms" : " Room"}
                    </div> */}

                    <div className="text-right">
                      ${Number(item.totalAmount) / 100}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        {bills.length === 0 && (
          <ul className="flex items-center h-52">
            <div className="flex justify-center w-full text-gray-400">
              No bills have been added yet.
            </div>
          </ul>
        )}
      </div>
    </div>
  );
};

export default BillsCard;
